<div class="relative z-10">
  <ig-expand-indicator #matMenuTrigger [matMenuTriggerFor]="menu" aria-label="open" class="absolute -left-4 top-[-13px]"
    [triggerText]="triggerText"></ig-expand-indicator>

  <mat-menu #menu="matMenu" (closed)="close.emit()"
    class="ig-text-color-edit !rounded-2xl px-6 py-2 {{menuClass}} {{inputMode==='textarea'?'ig-textarea':'ig-input'}}">
    <div class="flex justify-between items-center">
      <p class="text-xl font-semibold text-gray-600" igClickStopPropagation>Change Text and Color</p>
      <mat-icon
        class="text-gray-600 text-[14px] border-[1px] border-gray-600 flex items-center justify-center !w-4 !h-4 rounded-full cursor-pointer">
        close
      </mat-icon>
    </div>

    <div class="pt-6 pb-0" igClickStopPropagation>
      <ig-field [mode]="inputMode" [control]="form.get('text')" (onInputChange)="onTextChange($event)"
        label="Text content" [maxlength]="300" icon="title"></ig-field>
    </div>
    <div class="pt-0 pb-4" igClickStopPropagation>
      <ig-color-picker [color]="item.color" (slider)="onColorSlider($event)" (change)="onColorSlider($event)"
        (input)="onColorSlider($event)" [isShowIndicator]="false" triggerText="change text color"></ig-color-picker>
      <span class="ml-12 relative top-1 text-gray-600">Text Color</span>
    </div>
  </mat-menu>
</div>
